import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ef-user__skeleton"
}
const _hoisted_2 = {
  key: 1,
  class: "ef-user"
}
const _hoisted_3 = { class: "ef-line" }
const _hoisted_4 = { class: "ef-line" }
const _hoisted_5 = { class: "ef-user__infos" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-address-card" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-at" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-briefcase" }, null, -1)

import {onMounted, ref} from "vue";
import {storeUser} from "@/stores/user";
import Header from '@/components/Header.vue';
import User from "@/types/User";
import {useRoute, useRouter} from "vue-router";
import {randomColor} from '@/functions/utils.ts';
import EditUser from '@/modales/EditUser.vue';
import Subscribe from '@/modales/Subscribe.vue';
import Confirm from '@/modales/Confirm.vue';

//Router
import {storeSystem} from "@/stores/system";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();

const user = ref<User>({
  company: '',
  role: '',
  email: '',
  firstname: '',
  id: '',
  lastname: '',
  groupId: '',
  groupName: '',
  preferences: null,
});

const headerActions = [
  { icon: 'fa-solid fa-square-up-right', text: 'Inscrire à une formation', action: 'subscribe' },
  { icon: 'fa-solid fa-pen', text: 'Editer', action: 'edit' },
  { icon: 'fa-solid fa-trash', text: 'Supprimer', action: 'remove' },
];

const confirmAction = ref('');

const msgConfirm = ref('');
const showConfirm = ref(false);

const closeConfirm = () => {
  showConfirm.value = false;
};

const _storeSystem = storeSystem();

const router = useRouter();
const validConfirm = () => {
  showConfirm.value = false;
  switch (confirmAction.value) {
    case 'remove':
      loading.value = true;
      _storeUser.removeCollab(user.value.id).then(() => {
        router.push('/users');
        _storeSystem.addInfoTag({ id: '', type: 'success', text: 'Utilisateur supprimé' });
      });
      break;
  }
};

const removeUser = () => {
  confirmAction.value = 'remove';
  msgConfirm.value = `supprimer l'utilisateur ${user.value.firstname} ${user.value.lastname}`;
  showConfirm.value = true;
}

const showEditUser = ref(false);

const closeEditUser = () => {
  showEditUser.value = false;
}

const editUser = () => {
  showEditUser.value = true;
}

const showSubscribe = ref(false);

const closeSubscribe = () => {
  showSubscribe.value = false;
}

const subscribe = () => {
  showSubscribe.value = true;
}

const _storeUser = storeUser();
const loading = ref(true);

onMounted(() => {
  if (route.params.userId) {
    const userId = route.params.userId as string;
    _storeUser.getUserById(userId).then((response) => {
      user.value = response;
      loading.value = false;
    });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, " loading "))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(Header, {
              icone: "fa-solid fa-address-card",
              title: user.value.firstname + user.value.lastname,
              actions: headerActions,
              onEdit: editUser,
              onSubscribe: subscribe,
              onRemove: removeUser
            }, null, 8, ["title"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "ef-user__logo",
              style: _normalizeStyle(`background-color: ${_unref(randomColor)(user.value.id)}`)
            }, _toDisplayString(user.value.firstname[0]) + _toDisplayString(user.value.lastname[0]), 5),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _hoisted_6,
                _createTextVNode(_toDisplayString(user.value.firstname) + " " + _toDisplayString(user.value.lastname), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_7,
                _createTextVNode(" " + _toDisplayString(user.value.email), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_8,
                _createTextVNode(" " + _toDisplayString(user.value.company), 1)
              ])
            ])
          ])
        ])),
    _createVNode(EditUser, {
      userToEdit: user.value,
      open: showEditUser.value,
      onClose: closeEditUser
    }, null, 8, ["userToEdit", "open"]),
    _createVNode(Subscribe, {
      userToEdit: user.value,
      open: showSubscribe.value,
      onClose: closeSubscribe
    }, null, 8, ["userToEdit", "open"]),
    _createVNode(Confirm, {
      open: showConfirm.value,
      msg: msgConfirm.value,
      onClose: closeConfirm,
      onValid: validConfirm
    }, null, 8, ["open", "msg"])
  ], 64))
}
}

})